module.exports = __webpack_public_path__ + "static/spoticleanse-4301a12e67a63f78f1443ed29c552526.png";